import { render, staticRenderFns } from "./EmailLogs.vue?vue&type=template&id=5a5a3186&scoped=true&"
import script from "./EmailLogs.vue?vue&type=script&lang=js&"
export * from "./EmailLogs.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogs.vue?vue&type=style&index=0&id=5a5a3186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a3186",
  null
  
)

export default component.exports